import {
  CANCEL_APPOINTMENT_PROVIDER_ADMIN,
  CANCEL_APPOINTMENT_PROVIDER_ADMIN_FAILURE,
  CANCEL_APPOINTMENT_PROVIDER_ADMIN_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const cancelAppointmentProviderAdminReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case CANCEL_APPOINTMENT_PROVIDER_ADMIN:
      return { ...state, loading: true };
    case CANCEL_APPOINTMENT_PROVIDER_ADMIN_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case CANCEL_APPOINTMENT_PROVIDER_ADMIN_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default cancelAppointmentProviderAdminReducer;
